import React from "react";

export const SuperAdminIcon: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="48"
        viewBox="0 96 960 960"
        width="48"
      >
        <path d="M690.882 786q25.883 0 44-19Q753 748 753 722.118q0-25.883-18.118-44-18.117-18.118-44-18.118Q665 660 646 678.118q-19 18.117-19 44Q627 748 646 767q19 19 44.882 19ZM689.5 911q33.5 0 60.5-14t46-40q-26-14-51.962-21-25.961-7-54-7-28.038 0-54.538 7-26.5 7-51.5 21 19 26 45.5 40t60 14Zm3 65Q615 976 560 920.5T505 789q0-78.435 54.99-133.718Q614.98 600 693 600q77 0 132.5 55.282Q881 710.565 881 789q0 76-55.5 131.5t-133 55.5ZM480 973h-7.5q-2.5 0-7.353-1.905Q338 933 249 811q-89-122-89-277V337q0-19.257 10.875-34.662Q181.75 286.932 199 280l260-97q11-4 21-4t21 4l260 97q17.25 6.932 28.125 22.338Q800 317.743 800 337v228q-14-7-30-12.5t-30-7.5V337l-260-96-260 96v197q0 76 24.5 140T307 786.5q38 48.5 84 80.5t89 46q6 12 18 27t20 23q-11 5-20.5 7.5T480 973Zm0-396Z" />
      </svg>
    </div>
  );
};
